import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ProvideHero from "../../components/front/provider/ProvideHero";
import "../../assets/css/componentSpecificCss/dreamTools.css";

const FEATURES = [
  {
    icon: "📝",
    bg: "#e8f2fc",
    title: "Registration & Enrollment",
    text: "Simplify registrations with online enrollment, waitlists, digital waivers, and participant management."
  },
  {
    icon: "📅",
    bg: "#fff1ec",
    title: "Scheduling",
    text: "Build programs, manage instructors, locations, sessions, and schedule updates with ease."
  },
  {
    icon: "💳",
    bg: "#fff8e6",
    title: "Payments & Billing",
    text: "Accept secure online payments, recurring billing, invoices, and financial reporting."
  },
  {
    icon: "💬",
    bg: "#e8f2fc",
    title: "Parent Communication",
    text: "Keep families informed through announcements, emails, notifications, resources, and important updates."
  },
  {
    icon: "📊",
    bg: "#fff1ec",
    title: "Reporting & Analytics",
    text: "Gain insights into registrations, attendance, revenue, and program performance."
  },
  {
    icon: "📂",
    bg: "#fff8e6",
    title: "Resource Management",
    text: "Share documents, resources, forms, and educational materials with parents in one convenient location."
  }
];

const AI_FEATURES = [
  "Search and listing recommendations to help users discover relevant programs.",
  "AI messaging assistance to help organizers create customer communications.",
  "AI-generated program ideas, descriptions, images, and marketing content.",
  "Smart recommendations for scheduling and pricing programs.",
  "Financial insights and alerts to help organizers identify unusual activity.",
  "AI-powered analytics summaries and reports to help organizers understand performance."
];

const DreamTools = () => {
  return (
    <>
      <Helmet>
        <title>Dreamschools - Dream Tools</title>
        <link rel="canonical" href="https://www.dreamschools.com/dream-tools" />
      </Helmet>

      <ProvideHero />

      <div className="dt-page">
        <div className="dt-container">
          <section className="dt-intro">
            <span className="dt-eyebrow">All-in-one platform</span>
            <h1>Everything you need to run your programs</h1>
            <p>
              Dreamschools helps organizations manage children's activity and
              enrichment programs from registration to communication,
              scheduling, payments, reporting, and more, all from one
              easy-to-use platform.
            </p>
          </section>

          <svg
            className="dt-divider"
            viewBox="0 0 1180 48"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M0 24 C 150 0, 300 48, 450 24 S 750 0, 900 24 S 1080 48, 1180 24"
              fill="none"
              stroke="#1c75bc"
              strokeOpacity="0.25"
              strokeWidth="3"
            />
          </svg>

          <section>
            <h2 className="dt-section-heading">Dream Tools</h2>

            <div className="dt-grid">
              {FEATURES.map((feature, index) => (
                <div className="dt-card" key={index}>
                  <div
                    className="dt-icon-badge"
                    style={{ background: feature.bg }}
                  >
                    {feature.icon}
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.text}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="dt-ai-panel">
            <h2>AI-Powered Features</h2>
            <p>
              Dreamschools is expanding its AI-powered capabilities to help
              organizations save time, improve communication, and simplify daily
              administrative tasks.
            </p>

            <ul className="dt-ai-list">
              {AI_FEATURES.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {/* <section className="dt-cta">
            <h2>Ready to transform your programs?</h2>
            <p>
              Discover how Dreamschools can help simplify program management
              while creating a better experience for families, educators, and
              administrators.
            </p>
            <Link to="/partner" className="dt-cta-btn">
              Launch With Dreamschools
            </Link>
          </section> */}
        </div>
      </div>
    </>
  );
};

export default DreamTools;
